export default "__VITE_ASSET__BHACR2$7__"